module.exports = __webpack_public_path__ + "img/AlbumOfTheMonth.2d79396b.jpg";